"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.guardianshipUserFactory = void 0;
const Factory = require("factory.ts");
const guardianship_persona_factory_1 = require("./guardianship-persona.factory");
const persona = guardianship_persona_factory_1.guardianshipPersonaFactory.build();
exports.guardianshipUserFactory = Factory.Sync.makeFactory({
    id: Factory.each(i => i + 1),
    uuid: 'xxx-yyy-123',
    email_address: 'test@example.com',
    self_persona: persona
});
